exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../node_modules/postcss-loader/index.js??postcss!@angular/material/prebuilt-themes/indigo-pink.css"), "");

// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n\nbody {\n  padding: 0;\n  margin: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/cwseger/go/src/github.com/cwseger/travel-time-ui/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/Users/cwseger/go/src/github.com/cwseger/travel-time-ui/node_modules/postcss-loader?{"ident":"postcss"}!/Users/cwseger/go/src/github.com/cwseger/travel-time-ui/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = styles